import reducer from './recipes';
import { actionCreators, RecipesActionType } from './recipes.actionCreators';
import * as actionTypes from './recipes.actionTypes';

export * from './recipes'; // expose all types
export * from './recipes.selectors'; // expose all selectors
export type ActionType = RecipesActionType; // expose action-type alias
export { actionTypes, actionCreators }; // expose AT & AC
export default reducer; // reducer is the default
